/**
 * MoveInDialog — Area picker + confirmation for re-activating a moved-out resident.
 */

import { useState, useCallback } from 'react';

const MoveInDialog = ({
  residentName, locationData,
  onClose, onConfirm, saving,
}) => {
  const [selectedAreaId, setSelectedAreaId] = useState('');

  const handleSubmit = useCallback(() => {
    if (!selectedAreaId) return;
    onConfirm(selectedAreaId);
  }, [selectedAreaId, onConfirm]);

  return (
    <div className="pp-dialog-backdrop" onClick={onClose}>
      <div className="pp-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="pp-dialog__header">
          <h2 className="pp-dialog__title">Move Back In</h2>
          <button className="dp-drawer__close" onClick={onClose}>&#x2715;</button>
        </div>
        <div className="pp-dialog__body">
          <p style={{ margin: '0 0 var(--space-3)', lineHeight: 1.6 }}>
            Move <strong>{residentName}</strong> back into a room. Select the area below.
          </p>
          <div className="dp-drawer__field">
            <label className="dp-drawer__label">
              Select Area <span className="dp-drawer__required">*</span>
            </label>
            <select
              className="dp-drawer__select"
              value={selectedAreaId}
              onChange={(e) => setSelectedAreaId(e.target.value)}
            >
              <option value="">Select an area&hellip;</option>
              {(locationData || []).map((area) => (
                <option key={area.area_id} value={area.area_id}>
                  {area.area_name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="pp-dialog__footer">
          <button className="dp-btn dp-btn--cancel" onClick={onClose} disabled={saving}>
            Cancel
          </button>
          <button
            className="dp-btn dp-btn--primary"
            onClick={handleSubmit}
            disabled={saving || !selectedAreaId}
          >
            {saving ? 'Moving In\u2026' : 'Move Back In'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoveInDialog;
